import React from 'react';
import {useAllCollectedFormUrlsQuery} from 'api';
import useCondition from '../../useCondition';

export default () => {
  const {condition} = useCondition();
  const {data: {allCollectedFormUrls: {collectedFormUrls = []} = {}} = {}} =
    useAllCollectedFormUrlsQuery({
      fetchPolicy: 'cache-and-network',
    });

  if (!condition?.collectedFormUrls || !condition.collectedFormUrls.length) {
    return null;
  }

  return (
    <div className="pb-4 border-b border-c-border flex flex-col gap-2 last-of-type:border-none">
      <div className="flex items-center gap-1">
        <h4 className="m-0 font-bold">タグ連携フォーム</h4>
      </div>
      <div className="flex flex-wrap items-center gap-1">
        {collectedFormUrls
          .filter((collectedFormUrl) =>
            condition.collectedFormUrls.includes(collectedFormUrl.id),
          )
          .map((collectedFormUrl) => (
            <span
              key={collectedFormUrl.id}
              className="text-sm inline-block border border-c-border rounded-sm bg-c-bg px-2">
              {collectedFormUrl.title}
            </span>
          ))}
      </div>
    </div>
  );
};
